/**
 * 展示格式化(浏览域)。价格后端为「分」(int64),评分为浮点。
 * 兜底:非有限数 → 价格 0 / 评分 0.00(product-detail.md 逐字段兜底)。
 */

/** 价格分 → 元展示串。整数省小数,否则两位;非有限/缺失 → "0"。 */
export function formatYuan(fen?: number): string {
  if (typeof fen !== 'number' || !Number.isFinite(fen)) return '0';
  const yuan = fen / 100;
  return Number.isInteger(yuan) ? String(yuan) : yuan.toFixed(2);
}

/** 评分 → 两位小数串;非有限/缺失 → "0.00"。接受 number 或后端字符串(averageScore)。 */
export function formatRating(rating?: number | string): string {
  const n = typeof rating === 'string' ? Number(rating) : rating;
  if (typeof n !== 'number' || !Number.isFinite(n)) return '0.00';
  return n.toFixed(2);
}
